import React, {useEffect} from 'react'

import {useAnalyticsQueue} from '@invitae/analytics-queue'

import {AnalyticsQueueContext} from './analyticsQueueContext'
import {setGlobalAnalyticsQueue} from './globals'

export const AnalyticsQueueContextProvider = ({
  children,
  debug = false,
}: {
  children: React.ReactNode
  debug?: boolean
}) => {
  const analyticsQueue = useAnalyticsQueue({debug})
  useEffect(() => {
    // The global AnalyticsQueue reference is only needed to support Class components
    setGlobalAnalyticsQueue(analyticsQueue)
  }, [analyticsQueue])
  return <AnalyticsQueueContext.Provider value={analyticsQueue}>{children}</AnalyticsQueueContext.Provider>
}
